import React, { Component } from "react";

export default class FootLocation extends Component {
	state = {
		isOpen: false
	};
	handleToggle = () => {
    	this.setState({ isOpen: !this.state.isOpen });
  	};
	render() {
		return (
			<div className={'c-footer__locations__section__inner ' + (this.state.isOpen ? 'state-open' : "")}>
				<h3 className="c-footer__locations__header" onClick={this.handleToggle}>{ this.props.location.title }</h3>
				<div className="c-footer__locations__body">
					{this.props.location.address && 
						<div className="c-footer__address">
							<div className="c-footer__address__header scope-footer-text">
								<h4>Address</h4>
							</div>
							<div className="c-footer__address__text scope-footer-text" dangerouslySetInnerHTML={ {__html: this.props.location.address} }></div>
						</div>
					}
					{this.props.location.email && 
						<div className="c-footer__address">
							<div className="c-footer__address__header scope-footer-text">
								<h4>Email</h4>
							</div>
							<div className="c-footer__address__text scope-footer-text" dangerouslySetInnerHTML={ {__html: '<p><a href="mailto:' + this.props.location.email + '">' + this.props.location.email + '</a></p>' } }></div>
						</div>
					}
					{this.props.location.phone && 
						<div className="c-footer__address">
							<div className="c-footer__address__header scope-footer-text">
								<h4>Phone</h4>
							</div>
							<div className="c-footer__address__text scope-footer-text" dangerouslySetInnerHTML={ {__html: '<p><a  target="_self" href="' + this.props.location.phone_url + '">' + this.props.location.phone + '</a></p>' } }></div>
						</div>
					}
					{this.props.location.fax && 
						<div className="c-footer__address">
							<div className="c-footer__address__header scope-footer-text">
								<h4>Fax</h4>
							</div>
							<div className="c-footer__address__text scope-footer-text" dangerouslySetInnerHTML={ {__html: '<p><a  target="_self" href="' + this.props.location.fax_url + '">' + this.props.location.fax + '</a></p>' } }></div>
						</div>
					}
				</div>
			</div>
		);
	}  	
}